// foodmenu/editMenu.jsx
import React, { useState, useEffect } from "react";

export default function EditMenu({ item, onSubmit, onCancel }) {
  const [formData, setFormData] = useState({ name: "", price: "" });

  useEffect(() => {
    if (item) {
      setFormData({ _id: item._id, name: item.name, price: item.price });
    }
  }, [item]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form className="menu-form" onSubmit={handleSubmit}>
      <h4>{item ? "Edit Menu Item" : "Add Menu Item"}</h4>
      <div className="form-group p-1 d-flex gap-3 align-items-center">
        <input
          type="text"
          name="name"
          placeholder="Item Name"
          value={formData.name}
          onChange={handleChange}
          required
          style={{
            padding: 5,
            flex: 1,
            minWidth: 100,
            maxWidth: 200,
            border: "1px solid #ccc",
            borderRadius: 4,
          }}
        />
        <input
          type="number"
          name="price"
          placeholder="Price"
          value={formData.price}
          onChange={handleChange}
          required
          min="1"
          step="any"
          style={{
            padding: 5,
            flex: 1,
            minWidth: 100,
            maxWidth: 200,
            border: "1px solid #ccc",
            borderRadius: 4,
          }}
        />

        <div className="form-actions d-flex gap-2">
          <button type="submit" className="btn btn-primary">
            {item ? "Update" : "Add"} Item
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onCancel}
          >
            Cancel
          </button>
        </div>
      </div>
    </form>
  );
}
